<template>
    <div v-if="exibirGrid">
        <Loading v-bind:show="showLoading">
            <md-table md-card>
                <md-table-toolbar>
                    <h1 class="md-title">Roles De Para</h1>
                    <md-button class="md-raised md-primary" @click="exibirGrid = false"><md-icon>add</md-icon> Adicionar </md-button>
                </md-table-toolbar>

                <md-table-row>
                  <md-table-head>Sistema origem</md-table-head>
                  <md-table-head>Role</md-table-head>
                  <md-table-head>Sistema destino</md-table-head>
                  <md-table-head>Grupo AD</md-table-head>
                  <md-table-head>Descrição</md-table-head>
                  <md-table-head></md-table-head>
                </md-table-row>

                <md-table-row v-for="role in this.dadosAba" :key="role.id">
                  <md-table-cell>{{role.sistemaDe}}</md-table-cell>
                  <md-table-cell v-if="role.roleDe != ''">{{role.roleDe}}</md-table-cell>
                  <md-table-cell v-else>-</md-table-cell>
                  <md-table-cell>{{role.sistemaPara}}</md-table-cell>
                  <md-table-cell>{{role.rolePara}}</md-table-cell>
                  <md-table-cell>{{role.descricao}}</md-table-cell>
                  <md-table-cell>
                    <div>
                      <span @click="carregarItem(role)">
                        <md-icon class="actions">edit</md-icon>
                      </span>
                      <span @click="modalConfirmarExclusao(role.id)">
                        <md-icon class="actions">delete</md-icon>
                      </span>
                    </div>
                  </md-table-cell>
                </md-table-row>
            </md-table>
        </Loading>
    </div>
    <div v-else>
        <FormCadastrarPerfil ExibirGrid="exibirGrid" @closed="exibirGrid = true; carregarDados();" v-bind:model="model" />
    </div>
</template>

<script>
    import FormCadastrarPerfil from '@/components/FormCadastrarPerfil.vue'
    import DeParaService from '@/services/DeParaService.js'
    import Loading from '@/components/Loading';

    export default {
        name: 'DePara',
        data() {
            return {
                dadosAba: null,
                showLoading: false,
                exibirGrid: true,
                gestaoUsuariosService: null,
                dados: [],
                model: []
            }
        },
        components: {
            FormCadastrarPerfil,
            Loading
        },
        created() {
            if (this.$featureToggle.INTEGRA_DEPARA_GRID) {
                this.deParaService = new DeParaService(this);
                this.carregarDados();
            }
            else {
                this.$modal.alert(this.$msgFeatureToggle);
            }
        },
        methods: {
            carregarDados() {
                //Popula os dados da aba
                this.showLoading = true;
                this.deParaService.getAllDePara().then(
                    data => {
                        if (data.ok) {
                            this.dadosAba = data.dados;
                        }
                        else {
                            this.$modal.info(data.Mensagem);
                        }
                    },
                    error => {
                        if (error.status != 500)
                            this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        else
                            this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                    }).finally(() => {
                        this.showLoading = false;
                    });
            },
            modalConfirmarExclusao(id) {
                this.$modal.confirm("Deseja excluir o de para selecionado?", () => { this.excluirPerfil(id) });
            },

            excluirPerfil(id) {
                this.deParaService.deleteDePara(id).then(
                    data => {
                        if (data.ok) {
                            this.carregarDados();
                            this.$modal.info(data.mensagem);
                        }
                        else {
                            this.$modal.info(data.Mensagem);
                        }
                    },
                    error => {
                        if (error.status != 500)
                            this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        else
                            this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                    }).finally(() => {
                        this.showLoading = false;
                    });

                this.carregarDados();
            },

            carregarItem(role) {
                //this.dados = Object.assign({}, role);

                this.model = role;

                this.exibirGrid = false;
                
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-icon {
        cursor: pointer;
    }

        .md-icon:hover {
            opacity: 0.5;
        }

    .md-table-cell {
        background-color: white !important;
    }
</style>
